import { useEffect, useRef, useState } from 'react';

export const useElementOnScreen = (options: any) => {
  const containerRef = useRef<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  const callbackFunction: IntersectionObserverCallback = (entries, observe) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      setIsVisible(true);
    } else setIsVisible(false);
  };

  useEffect(() => {
    if( globalThis.window !== undefined) {
        const observer = new IntersectionObserver(callbackFunction, options);
        if (containerRef.current) observer.observe(containerRef.current);
        return () => {
          if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }
  }, [containerRef.current]);

  return { containerRef, isVisible };
};